module.exports = "../images/icons/icon-fb.svg";